import React from "react";

import PassedIcon from "./icons/PassedIcon";
import TieVoteIcon from "./icons/TieVoteIcon";
import PendingIcon from "./icons/PendingIcon";
import UpcomingIcon from "./icons/UpcomingIcon";
import FailedVoteIcon from "./icons/FailedVoteIcon";
import CompleteIcon from "./icons/CompleteIcon";
import PassingIcon from "./icons/PassingIcon";
import FailingIcon from "./icons/FailingIcon";

const mapPdfVoteIcon = (voteStatus) => {
  const icon = VoteIcons[voteStatus ? voteStatus.toLowerCase() : ""]();

  return icon;
};

const Icons = () => {
  let icons = [];

  icons[""] = () => <></>;
  icons["passed"] = () => <PassedIcon />;
  // icons["passing"] = () => <PassingIcon />;
  icons["failed"] = () => <FailedVoteIcon />;
  // icons["failing"] = () => <FailingIcon />;
  icons["complete"] = () => <CompleteIcon />;
  icons["voting in progress"] = () => <PendingIcon />;
  icons["upcoming"] = () => <UpcomingIcon />;
  icons["tie Vote"] = () => <TieVoteIcon />;

  return icons;
}
const VoteIcons = Icons();

export default mapPdfVoteIcon;